<template>
  <div class="login-page">
    <div class="background-blue">
      <div class="logo">
        <div class="brand">
          <span>Welcome</span><br />
          <span>to easypaper</span>
        </div>
        <div class="trace"></div>
      </div>
    </div>
    <div class="container-login">
      <div class="box-login">
        <div class="title">
          <span>Sign In</span>
        </div>
        <div>
          <input
            v-model="email"
            class="inputs user"
            :class="{ 'error-input': (validEmail && !isEmail(email))
            || (validEmail && email ==='') }"
            type="email"
            placeholder="Email"
          >
          <template v-if="validEmail && email ===''">
            <span class="error-msg-login">
              Field required*</span>
          </template>
          <template v-if="(validEmail && !isEmail(email) && email!== '')">
            <span class="error-msg-login">
              Fill in the field correctly*</span>
          </template>
        </div>
        <div>
          <input
            v-model="password"
            class="inputs padlock"
            :class="{ 'error-input': validPassword && password === '' }"
            type="password"
            placeholder="Password"
          >
          <template v-if="validPassword && password === ''">
            <span class="error-msg-login password">
              Field required*</span>
          </template>
        </div>
        <div v-if="errorMessage" class="error">
          {{ errorMessage }}
        </div>
        <div>
          <button
            @click="valid()"
            class="btn-login"
          >Login</button>
          <template v-if="loaderButton">
            <LoaderButton />
          </template>
        </div>
        <div
          class="forgot-password"
          @click="forgotPassword()"
        >Forgot password?</div>
      </div>
    </div>
  </div>
</template>
<script>
import LoaderButton from '@/components/Loader/LoaderButton.vue';
import { isSignedIn } from '../auth/auth';


export default {
  name: 'login',
  data() {
    return {
      loaderButton: false,
      email: '',
      password: '',
      validEmail: false,
      validPassword: false,
      emailValidation: false,
      errorMessage: '',
    };
  },
  components: {
    LoaderButton,
  },
  mounted() {
    if (isSignedIn()) {
      this.$router.push('home');
    }
  },
  methods: {
    isEmail(email) {
      // eslint-disable-next-line
      const exp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
      if (email.search(exp) !== -1) {
        return true;
      }
      return false;
    },
    forgotPassword() {
      return this.$router.push('password-recovery/');
    },
    valid() {
      if (!this.isEmail(this.email)) {
        this.validEmail = true;
      }
      if (!this.password) {
        this.validPassword = true;
      }
      if ((this.email && this.isEmail(this.email))
        && this.password
      ) {
        this.login();
      }
    },
    async login() {
      this.LoaderButton = true;
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: this.email,
          password: this.password,
        }),
      };
      fetch(`${process.env.VUE_APP_API_URL}/v1/login`, requestOptions)
        .then(async (response) => {
          const data = await response.json();

          // check for error response
          if (!response.ok) {
            // get error message from body or default to response status
            const error = (data && data.error) || response.status;
            this.LoaderButton = false;
            return Promise.reject(error);
          }
          localStorage.setItem('user', data.user.name);
          localStorage.setItem('token', data.token);
          this.$store.commit('UPDATE_USER', {
            name: data.user.name, email: data.user.email, token: data.token,
          });
          this.LoaderButton = false;
          this.$store.commit('UPDATE_TABLE', 0);
          return this.$router.push('home');
        })
        .catch((error) => {
          this.LoaderButton = false;
          this.errorMessage = error;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
// esses estilos estão aqui pois no _input ele não encontrava o caminho
.logo {
  background-image: url("./../assets/background/background-login.svg");
  background-size: cover;
}
.user {
  background-image: url("../../src/assets/icons/user.svg");
  background-position: 17px;
  margin-bottom: 25px;
  position: relative;
}
.padlock {
  background-image: url("../../src/assets/icons/password.svg");
  background-position: 17px;
  position: relative;
}
.error-msg-login {
  position: absolute;
  color: $declined;
  font-size: 12px;
  white-space: nowrap;
  margin-top: -25px;
  left: 0;
  &.password {
    margin-top: 0px;
  }
}
.error {
  color: $declined;
  font-size: 12px;
}
</style>
